import { createSlice } from "@reduxjs/toolkit";

const slice = createSlice({
  name: "ui",
  initialState: {
    loading: false,
    progress: 0, // dY`^ new field for circular progress
    globalAlerts: [],
  },
  reducers: {
    setLoading(state, action) {
      state.loading = action.payload;
      if (!action.payload) {
        state.progress = 0; // reset when loading stops
      }
    },
    setProgress(state, action) {
      state.progress = action.payload;
    },
    setGlobalAlerts(state, action) {
      state.globalAlerts = Array.isArray(action.payload)
        ? action.payload
        : [];
    },
    addGlobalAlert(state, action) {
      const payload = action.payload;
      if (!payload || !payload.id) return;
      const idx = state.globalAlerts.findIndex(
        (alert) => alert.id === payload.id
      );
      if (idx >= 0) {
        state.globalAlerts[idx] = payload;
      } else {
        state.globalAlerts.push(payload);
      }
    },
    removeGlobalAlert(state, action) {
      state.globalAlerts = state.globalAlerts.filter(
        (alert) => alert.id !== action.payload
      );
    },
    clearGlobalAlerts(state) {
      state.globalAlerts = [];
    },
  },
});

export const {
  setLoading,
  setProgress,
  setGlobalAlerts,
  addGlobalAlert,
  removeGlobalAlert,
  clearGlobalAlerts,
} = slice.actions;
export default slice.reducer;
